import vuex from "src/vuex"
import * as Cookies from "js-cookie";

export default (to, from, next) => {
  if(Cookies.getJSON("token")){
    vuex.dispatch("redirectToMainMenu");
  }
  next();
};
